import React from 'react';
import './Button.css';

/**
 * SearchInput Component
 * Standardized search input field
 * 
 * @param {string} placeholder - Placeholder text
 * @param {string} value - Input value
 * @param {function} onChange - Change handler
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional input props
 */
const SearchInput = ({ 
  placeholder = 'Search...', 
  value, 
  onChange, 
  className = '',
  ...props
}) => {
  return (
    <input
      type="text"
      className={`search-input ${className}`.trim()}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};

export default SearchInput;

